// Los nombres de emisor/receptor llegan HTML-escapados desde el blueprint
// (ej. 'AT&amp;T'); se decodifican antes de mostrarse o matchearse.
export const decodeHtmlEntities = (value: string): string =>
	(value || '')
		.replace(/&amp;/gi, '&')
		.replace(/&quot;/gi, '"')
		.replace(/&apos;|&#0?39;/gi, "'")
		.replace(/&lt;/gi, '<')
		.replace(/&gt;/gi, '>');

export const toProperName = (name: string): string =>
	decodeHtmlEntities(name)
		.toLowerCase()
		.split(' ')
		.map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word))
		.join(' ');

// El fiscal-engine deja invoice_total en 0 en CFDIs de telecom/IEPS: un total
// no positivo no es confiable y se cae al subtotal.
export const getInvoiceAmount = (invoice: any): number => {
	const total = invoice?.invoice_total ?? invoice?.total;
	return typeof total === 'number' && total > 0
		? total
		: (invoice?.invoice_subtotal ?? 0);
};

// Gastos SIEMPRE por subtotal: es la base deducible y el campo que el
// blueprint puebla de forma confiable.
export const getExpenseAmount = (invoice: any): number =>
	invoice?.invoice_subtotal ?? 0;

// El fiscal-engine emite los gastos como UNA FILA POR CONCEPTO repitiendo los
// montos de la factura completa (sumarlos duplica). Sin uuid en los docs, la
// factura se reconstruye con esta llave heurística; los conceptos quedan en
// `concepts` para desglose.
export const groupExpenseConcepts = (docs: any[]): any[] => {
	const byInvoice = new Map<string, any>();
	const toConcept = (doc: any) => ({
		description: doc?.description,
		deductibility: doc?.deductibility,
		deductibilityReason: doc?.deductibility_reason,
		creditableIva: doc?.item_creditable_iva,
	});
	(docs ?? []).forEach((doc) => {
		const key = `${(doc?.issuer_name || '').toLowerCase().trim()}|${(doc?.issue_date || '').slice(0, 10)}|${doc?.invoice_subtotal}|${doc?.invoice_total}`;
		const group = byInvoice.get(key);
		if (group) {
			group.concepts.push(toConcept(doc));
		} else {
			byInvoice.set(key, { ...doc, concepts: [toConcept(doc)] });
		}
	});
	// La deducibilidad viene POR CONCEPTO; a nivel factura se marca deducible
	// cuando al menos un concepto lo es (IVA acreditable parcial).
	return [...byInvoice.values()].map((group) => ({
		...group,
		deductibility: group.concepts.some(
			(concept: any) => concept?.deductibility === 'Deducible',
		)
			? 'Deducible'
			: group.deductibility,
	}));
};

export const sortInvoicesByDateDesc = (invoices: any[]): any[] =>
	[...invoices].sort(
		(a: any, b: any) =>
			(new Date(b?.issue_date || 0).getTime() || 0) -
			(new Date(a?.issue_date || 0).getTime() || 0),
	);

export const haveAcquisitionsFromApprovalFlow = (declarationsOverview: any) => {
	const haveAcquisitionsFromApprovalFlow = declarationsOverview?.some(
		(declaration: any) =>
			declaration?.declarations?.some((declarationItem: any) => {
				return (
					declarationItem.isAcquired &&
					declarationItem?.acquisitionAdditionalInformation?.source ===
						'approval_flow'
				);
			}),
	);

	return haveAcquisitionsFromApprovalFlow;
};
